import React, {useState} from 'react';
// import nectrLogo from '../../static/images/Pink logo - no background - just logo.png';
import ContactModal from './ContactModal';

const Footer = () => {

    const [showContact, setShowContact] = useState(false)

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-left">
                    {/*<img src={nectrLogo} alt="Nectr Design" className="footer-logo" />*/}
                    <p className="footer-copy">© 2025 Nectr Design. All rights reserved.</p>
                </div>
                <div className="footer-links">
                    <a href="/privacy">Privacy</a>
                    <a href="/terms">Terms</a>
                    <button className="footer-link-btn" onClick={() => setShowContact(true)}>Contact</button>
                </div>
            </div>
            {showContact && <ContactModal onClose={() => setShowContact(false)} />}
        </footer>
    );
};

export default Footer;
